<template>
    <v-select
        :options="options"
        :value="value"
        :name="name"
        :placeholder="placeholder"
        :multiple="multiple"
        :disabled="disabled"
        @input="input"
        class="input input-block input-text-center quiz-dropdown subject-select"
    >
        <template #no-options>{{ $t('sorry_no_natching_options') }}</template>
    </v-select>
</template>

<script>
export default {
    name: 'XSelect',

    props: {
        value: {},

        name: {},

        placeholder: {},

        options: {
            type: Array
        },

        multiple: {},

        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        input(val) {
            this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss">
.subject-select {
    .vs__dropdown-toggle {
        height: 100%;

        .vs__selected-options {
            position: relative;
            column-gap: 0.5rem;
            padding-left: 0.5rem;

            .vs__selected {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
            }
        }
    }
}
</style>
